import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

export const getRostersAsync = createAsyncThunk(
  "shifts/getRostersAsync",
  async (data, {rejectWithValue}) => {
    try{
      const response = await httpClient.get(`/patrols/${data}/rosters`);
      return {
        data: response.data,
        patrolId: data,
        success: response.status == 200 ? true : false,
        status: response.status
      };
    } catch(e) {
      return rejectWithValue({
        message: e.response?.data?.errors?.[0],
      });
    }
  } 
);

export const getShiftsAsync = createAsyncThunk(
  "shifts/getShiftsAsync",
  async (data, {rejectWithValue}) => {
    try{
      const response = await httpClient.post(`/rosters/${data.rosterId}`);
      return {
        data: response.data,
        success: response.status == 200 ? true : false,
        status: response.status
      };
    } catch(e) {
      return rejectWithValue({
        message: e.response?.data?.errors?.[0],
      });
    }
  } 
);

export const updateShiftsAsync = createAsyncThunk(
  "shifts/updateShiftsAsync",
  async (data, {rejectWithValue, getState}) => {
    const state = getState();
    try{

      let duties = state.shifts.rosters.find(r => r.id == data.rosterId).duties;
      duties = duties.map(d => {
        //const {dutyTypeCode, dutyTypeId, finishTime, startTime, payTypeCode, rosterArea} = d;
        return d;
        //{dutyTypeCode, dutyTypeId, finishTime, startTime, payTypeCode, rosterArea};
      });
      //console.log('SEND', duties);
      const response = await httpClient.post(`/rosters/${data.rosterId}`, {
        ...state.shifts.rosters.find(r => r.id == data.rosterId),
        duties
      });
      return {
        data: data,
        success: response.status == 200 ? true : false,
        status: response.status
      };
    } catch(e) {
      //console.log(e);
      const errors = e.response?.data;
      const parsedMessages = [];
 
      for (const key in errors) {
        const messages = errors[key];
        const match = key.match(/\[(\d+)\]/);
        const index = match ? match[1] : null;
      
        messages.forEach(msg => {
          parsedMessages.push(index ? `ID: ${index} ${msg}` : msg);
        });
      }
      return rejectWithValue({
        message: parsedMessages.join("\n"),
      });
    }
  } 
);

const shiftsSlice = createSlice({
  name: "shifts",
  initialState: {
    rosters: [],
    loading: false,
    error: null,
    nextId: 10000,
  },
  reducers: {
    setShifts: (state, action) => {
      state.shifts = action.payload
    },
    addShift: (state, action) => {
      state.nextId = state.nextId + 1;
      const {startTime, finishTime, dutyTypeId, payTypeCode, payTypeName, dutyTypeCode, rosterArea, rosterId} = action.payload;

      state.rosters.find(r => r.id == rosterId).duties.push({
        startTime, finishTime, dutyTypeId, payTypeCode, dutyTypeCode, rosterArea, payTypeName, rosterId,
        id: state.nextId
      });
    },
    updateShift: (state, action) => {
      console.log('ACTION SHIFT', action.payload);
      const dindex = state.rosters.find(r => r.id == action.payload.rosterId).duties.findIndex((shift) => shift.id === action.payload.id);
      const rindex = state.rosters.findIndex(r => r.id == action.payload.rosterId);
      if (dindex !== -1 && rindex !== -1) {
        const {id, startTime, finishTime, dutyTypeId, payTypeCode, dutyTypeCode, payTypeName, rosterArea, rosterId} = action.payload;
        state.rosters[rindex].duties[dindex] = {id, startTime, finishTime, dutyTypeId, payTypeCode, dutyTypeCode, payTypeName, rosterArea, rosterId};
      }
    },
    deleteShift: (state, action) => {
      const rindex = state.rosters.findIndex(r => r.id == action.payload.rosterId);
      state.rosters[rindex].duties = state.rosters[rindex].duties.filter(d => d.id != action.payload.id);

    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRostersAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRostersAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        //state.nextId = 10000;
        //let count = 1;
        state.rosters = action.payload.data.map(roster => ({
          ...roster,
          duties: roster.duties.map( duty => ({
            ...duty,
          }))
        }));
      })
      .addCase(getRostersAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Rosters retrieval failed.';
      })
      
      
      .addCase(getShiftsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getShiftsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.shifts = action.payload.data;
      })
      .addCase(getShiftsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Duties retrieval failed.';
      })


      .addCase(updateShiftsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateShiftsAsync.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        // const data = action.payload.data;
        // const shift = state.shifts.find(s => s.id == data.id);
        // Object.assign(shift, data);
        //state.shifts.push({...data, id: Math.floor(Math.random() * 100)});
      })
      .addCase(updateShiftsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Duties retrieval failed.';
      })
  }
});

export const { setShifts, addShift, updateShift, deleteShift } =
  shiftsSlice.actions;
export default shiftsSlice.reducer;
